/* eslint-disable no-debugger */
<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Validação de Documentos</span>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill> Dados do Aluno</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              disabled
              v-model="dataRegistration.name"
            />
            <label class="user-label1">
              Nome do Aluno <span class="validRed">*</span>
            </label>
            <div @click.stop="findById(dataRegistration)" class="iconSelect">
              <div role="button">
                <b-icon-plus scale="2"></b-icon-plus>
              </div>
            </div>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.cpf"
              maxlength="18"
            />
            <label class="user-label1">
              CPF <span class="validRed">*</span>
            </label>
          </div>

          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.courseName"
            />
            <label class="user-label1"> Curso </label>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span>
          <b-icon-cloud-fill></b-icon-cloud-fill> Endereço e Contatos</span
        >
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.address"
            />
            <label class="user-label1"> Endereço </label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.number"
            />
            <label class="user-label1">Número</label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.district"
            />
            <label class="user-label1"> Bairro </label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.city"
            />
            <label class="user-label1"> Cidade </label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.uf"
            />
            <label class="user-label1"> UF </label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.phone"
            />
            <label class="user-label1"> Contato </label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.email"
            />
            <label class="user-label1"> Email </label>
          </div>
          <div class="input-group">
            <input
              required
              disabled
              class="input borderInput"
              v-model="dataRegistration.instagram"
            />
            <label class="user-label1"> Instagram </label>
          </div>
        </div>

        <div class="rowContet">
          <div class="input-group">
            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Faculdades
                escolhidas</span
              >
              <div class="rowContent">
                <div class="input-group">
                  <textarea
                    class="inputTextArea"
                    rows="3"
                    max-rows="6"
                    disabled
                    v-model="dataRegistration.faculdadesEscolhidas"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="input-group">
            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Cursos escolhidos</span
              >
              <div class="rowContent">
                <div class="input-group">
                  <textarea
                    class="inputTextArea"
                    rows="3"
                    max-rows="6"
                    disabled
                    v-model="dataRegistration.cursosEscolhido"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="input-group">
            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Informações antiga
                escola</span
              >
              <div class="input-group mt-4">
                <input
                  required
                  disabled
                  class="input borderInput"
                  v-model="student.nameOldSchool"
                />
                <label class="user-label1"> Nome </label>
              </div>
              <div class="input-group mt-4">
                <input
                  required
                  disabled
                  class="input borderInput"
                  v-model="student.cityOldSchool"
                />
                <label class="user-label1">Cidade</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cash-stack /> Histórico</span>
        <div class="rowContent" style="flex-direction: column">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              bottom: 10px;
              position: relative;
              align-items: center;
            "
          >
            <div class="radio-input">
              <label class="cyberpunk-checkbox-label">
                <input
                  disabled
                  type="checkbox"
                  v-model="student.isStudentOfOmega"
                  class="cyberpunk-checkbox"
                />
                Aluno Ômega</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  disabled
                  type="checkbox"
                  v-model="student.isOldStudentOfOmega"
                  class="cyberpunk-checkbox"
                />
                Ex-Aluno Ômega</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  disabled
                  type="checkbox"
                  v-model="student.isSchoolPublic"
                  class="cyberpunk-checkbox"
                />
                Escola pública</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  disabled
                  type="checkbox"
                  v-model="student.isResideForaVicosa"
                  class="cyberpunk-checkbox"
                />
                Reside fora de viçosa</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer" v-if="responsible.id">
        <span>
          <b-icon-cloud-fill></b-icon-cloud-fill> Dados do Responsável</span
        >
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="responsible.name"
            />
            <label class="user-label"> Nome </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="responsible.cpf"
            />
            <label class="user-label"> CPF </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="responsible.rg"
            />
            <label class="user-label"> RG </label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="responsible.telefone"
            />
            <label class="user-label"> Contato </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="responsible.email"
            />
            <label class="user-label"> Email </label>
          </div>
          <b-button class="btnsSave" @click="updateResponsible"
            >Atualizar</b-button
          >
        </div>
      </div>
      <div class="rowContainer" v-if="bondmand.id">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill> Dados do Fiador</span>
        <div class="rowContent">
          <div class="input-group">
            <input required class="input borderInput" v-model="bondmand.name" />
            <label class="user-label"> Nome </label>
          </div>
          <div class="input-group">
            <input required class="input borderInput" v-model="bondmand.cpf" />
            <label class="user-label"> CPF </label>
          </div>
          <div class="input-group">
            <input required class="input borderInput" v-model="bondmand.rg" />
            <label class="user-label"> RG </label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="bondmand.telefone"
            />
            <label class="user-label"> Contato </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="bondmand.email"
            />
            <label class="user-label"> Email </label>
          </div>
          <b-button class="btnsSave" @click="updateBondsman"
            >Atualizar</b-button
          >
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill>Anexos</span>
        <div class="rowContent">
          <div class="pa-md" style="max-width: 900px">
            <div class="expansion-item">
              <div
                :class="[
                  'header',
                  { 'bg-primary text-white': isOpen.documentsStudent },
                ]"
                @click="toggleEditor('documentsStudent')"
              >
                <span> <b-icon-plus-square-fill /> Documentos do Aluno</span>
                <i class="material-icons" :class="{ 'text-white': isOpen }">
                </i>
              </div>
              <transition name="slide">
                <div
                  v-if="isOpen.documentsStudent"
                  class="editor-content"
                  @focusin.stop
                >
                  <label
                    v-if="filesStudent.length > 0"
                    style="float: right; margin-right: 10px"
                  >
                    <input
                      type="checkbox"
                      @change="toggleAll('filesStudent', $event.target.checked)"
                    />
                    Aprovar Todos
                  </label>
                  <div class="ContentTable" style="color: #3a4750; width: 100%">
                    <div
                      v-for="file in filesStudent"
                      :key="file.id"
                      class="rowDocs"
                    >
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong
                            style="
                              color: #403b74;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >{{
                              documentNames[file.fileType] || file.fileType
                            }}</strong
                          >
                        </span>
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div
                          style="
                            width: 25px;
                            height: 25px;
                            background: #e1e1e1;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 4px;
                          "
                        >
                          <a
                            href="#"
                            @click.prevent="
                              downloadFile(file.ref, file.fileType)
                            "
                            style="
                              color: rgb(1, 136, 200);
                              text-decoration: none;
                            "
                          >
                            <b-icon-download scale="1.5"></b-icon-download>
                          </a>
                        </div>
                        <label class="cyberpunk-checkbox-label">
                          <input
                            type="checkbox"
                            v-model="fileModel[file.fileType]"
                            class="cyberpunk-checkbox"
                          />
                          {{
                            fileModel[file.fileType] ? "Aprovado" : "Aprovar"
                          }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="pa-md" style="max-width: 900px">
            <div class="expansion-item">
              <div
                :class="[
                  'header',
                  { 'bg-primary text-white': isOpen.documentsResp },
                ]"
                @click="toggleEditor('documentsResp')"
              >
                <span>
                  <b-icon-plus-square-fill /> Documentos do Responsável</span
                >
                <i class="material-icons" :class="{ 'text-white': isOpen }">
                </i>
              </div>
              <transition name="slide">
                <div
                  v-if="isOpen.documentsResp"
                  class="editor-content"
                  @focusin.stop
                >
                  <label
                    v-if="filesResp.length > 0"
                    style="float: right; margin-right: 10px"
                  >
                    <input
                      type="checkbox"
                      @change="toggleAll('filesResp', $event.target.checked)"
                    />
                    Aprovar Todos
                  </label>
                  <div class="ContentTable" style="color: #3a4750; width: 100%">
                    <div
                      v-for="fileResp in filesResp"
                      :key="fileResp.id"
                      class="rowDocs"
                    >
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong
                            style="
                              color: #403b74;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >{{
                              documentNames[fileResp.fileType] ||
                              fileResp.fileType
                            }}</strong
                          >
                        </span>
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div
                          style="
                            width: 25px;
                            height: 25px;
                            background: #e1e1e1;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 4px;
                          "
                        >
                          <a
                            href="#"
                            @click.prevent="
                              downloadFile(fileResp.ref, fileResp.fileType)
                            "
                            style="
                              color: rgb(1, 136, 200);
                              text-decoration: none;
                            "
                          >
                            <b-icon-download scale="1.5"></b-icon-download>
                          </a>
                        </div>
                        <label class="cyberpunk-checkbox-label">
                          <input
                            type="checkbox"
                            v-model="fileModel[fileResp.fileType]"
                            class="cyberpunk-checkbox"
                          />
                          {{
                            fileModel[filesResp.fileType]
                              ? "Aprovado"
                              : "Aprovar"
                          }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="pa-md" style="max-width: 900px">
            <div class="expansion-item">
              <div
                :class="[
                  'header',
                  { 'bg-primary text-white': isOpen.documentsBond },
                ]"
                @click="toggleEditor('documentsBond')"
              >
                <span> <b-icon-plus-square-fill /> Documentos do Fiador</span>
                <i class="material-icons" :class="{ 'text-white': isOpen }">
                </i>
              </div>
              <transition name="slide">
                <div
                  v-if="isOpen.documentsBond"
                  class="editor-content"
                  @focusin.stop
                >
                  <label
                    v-if="this.filesBond.length > 0"
                    style="float: right; margin-right: 10px"
                  >
                    <input
                      type="checkbox"
                      @change="toggleAll('filesBond', $event.target.checked)"
                    />
                    Aprovar Todos
                  </label>
                  <div class="ContentTable" style="color: #3a4750; width: 100%">
                    <div
                      v-for="bond in filesBond"
                      :key="bond.id"
                      class="rowDocs"
                    >
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong
                            style="
                              color: #403b74;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >{{
                              documentNames[bond.fileType] || bond.fileType
                            }}</strong
                          >
                        </span>
                      </div>
                      <div style="display: flex; gap: 10px">
                        <div
                          style="
                            width: 25px;
                            height: 25px;
                            background: #e1e1e1;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 4px;
                          "
                        >
                          <a
                            href="#"
                            @click.prevent="
                              downloadFile(bond.ref, bond.fileType)
                            "
                            style="
                              color: rgb(1, 136, 200);
                              text-decoration: none;
                            "
                          >
                            <b-icon-download scale="1.5"></b-icon-download>
                          </a>
                        </div>
                        <label class="cyberpunk-checkbox-label">
                          <input
                            type="checkbox"
                            v-model="fileModel[bond.fileType]"
                            class="cyberpunk-checkbox"
                          />
                          Aprovar
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill>Observações</span>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataRegistration.observation"
            />
            <label class="user-label">Observações</label>
          </div>
        </div>
      </div>
      <div class="rowContainer" style="margin-bottom: 30px">
        <div>
          <div class="btnsContainer">
            <b-button
              class="btnsSave"
              style="background: red"
              v-b-modal.modal-aprovedReg
              @click="setObs"
              v-if="this.dataRegistration.studentCourse.status !== 'reprovado'"
              >Reprovar</b-button
            >

            <b-button
              class="btnsSave"
              style="background: green"
              v-if="this.dataRegistration.studentCourse.status !== 'aprovado'"
              @click="approveCourse"
              >Aprovar</b-button
            >
          </div>
        </div>
      </div>
      <b-modal id="modalStudent" hide-footer hide-header centered size="xl">
        <div
          style="
            width: 100%;
            display: flex;
            position: relative;
            flex-direction: column;
          "
        >
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <b-button
              class="closeModalRegister"
              @click="$bvModal.hide('modalStudent')"
            >
              X
            </b-button>
          </div>
          <Student />
        </div>
      </b-modal>
      <b-modal id="modal-aprovedReg" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Reprovar Matrícula</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                Digite as observações da reprovação.
              </p>
            </div>

            <div class="rowContainer" style="width: 100%">
              <span> <b-icon-cloud-fill></b-icon-cloud-fill>Observações</span>
              <div class="rowContent">
                <div class="input-group">
                  <textarea
                    class="inputTextArea"
                    rows="3"
                    max-rows="6"
                    v-model="dataRegistration.observation"
                  />
                </div>
              </div>
            </div>
          </section>

          <div class="btnsModalActions">
            <button
              class="btnCancel"
              @click="$bvModal.hide('modal-aprovedReg')"
            >
              Fechar
            </button>
            <button
              class="btnsSave"
              style="background: red; width: 40%"
              @click="rejectCourse"
            >
              Reprovar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import CourseService from "../../services/course";
import Student from "../GeneralStudents/Student.vue";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { ValidadeCourse } from "../../validators/course";

export default {
  components: {
    Student,
  },
  data() {
    return {
      documentNames: {
        rg: "RG Aluno - Frente",
        pix: "PIX",
        "rg-verso": "RG Aluno - Verso",
        cpf: "CPF Aluno",
        compResi: "Residência",
        compResiOrigem: "Residência de Origem",
        rgresp: "RG do Responsável - Frente",
        cpfresp: "CPF do Responsável",
        "rgresp-verso": "RG do Responsável - Verso",
        comproResiResp: "Residência do Responsável",
        rgFiador: "RG do Fiador - Frente",
        cpfFiador: "CPF do Fiador",
        "rgFiador-verso": "RG do Fiador - Verso",
        comproResiFiador: "Residência do Fiador",
      },
      isOpen: {
        documentsStudent: false,
        documentsResp: false,
        documentsBond: false,
      },
      dataRegistration: {
        id: "",
        name: "",
        cpf: "",
        address: "",
        district: "",
        city: "",
        number: "",
        courseName: "",
        phone: "",
        email: "",
        uf: "",
        observation: "",
        studentCourse: [
          {
            bondsmans: null,
            responsibles: null,
            id: "",
            studentId: "",
            courseId: "",
            status: "",
            name: "",
            documentsApproved: {
              id: "",
              studentCourseId: "",
              status: "",
              observation: "",
              documentsValids: null,
            },
          },
        ],
        faculdadesEscolhidas: [],
        cursosEscolhido: [],
        instagram: "",
      },
      allStudents: [],
      student: {},
      course: {},
      files: {},
      filesStudent: {},
      filesResp: {},
      filesBond: {},
      fileModel: {},
      documentsValids: {},
      spinLoadingActionsButton: false,
      bondmand: {
        id: "",
        name: "",
        cpf: "",
        rg: "",
        telefone: "",
        email: "",
      },
      responsible: {
        id: "",
        name: "",
        cpf: "",
        rg: "",
        telefone: "",
        email: "",
      },
    };
  },
  computed: {
    ...mapState({
      dataSearchRegistration: (state) => state.dataSearchRegistration,
    }),
  },
  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_REGISTRATION",
      "SET_DATA_SEARCH_FROM_STUDENT",
    ]),
    toggleEditor(section) {
      this.isOpen[section] = !this.isOpen[section];
    },
    toggleAll(category, status) {
      this[category].forEach((file) => {
        this.$set(this.fileModel, file.fileType, status);
      });
    },
    clearInputs() {
      this.SET_DATA_SEARCH_FROM_REGISTRATION({});
    },
    setObs() {
      this.dataRegistration.observation = "Sua matrícula foi reprovada!";
    },
    async approveCourse() {
      this.dataRegistration.status = "aprovado";
      this.dataRegistration.observation =
        "Parabéns, sua matrícula foi aprovada!";
      const validDocuments = {};
      this.files.forEach((file) => {
        validDocuments[file.fileType] = !!this.fileModel[file.fileType];
      });

      await this.updateCourse(validDocuments);

      this.$bvModal.hide("modal-aprovedReg");
      this.$toast.open({
        message: "Matrícula foi aprovada!",
        type: "success",
      });
    },
    async rejectCourse() {
      this.dataRegistration.status = "reprovado";
      const validDocuments = {};
      this.files.forEach((file) => {
        validDocuments[file.fileType] = !!this.fileModel[file.fileType];
      });

      await this.updateCourse(validDocuments);

      this.$toast.open({
        message: "Matrícula foi reprovada!",
        type: "info",
      });
    },
    async saveOrUpdateCourse() {
      const isNotValid = ValidadeCourse(this.dataRegistration);
      if (isNotValid) {
        this.$toast.open({
          message: isNotValid.message,
          type: "info",
        });
        return;
      }
      if (this.dataRegistration.id === "") {
        await this.saveCourse();
      } else {
        await this.updateCourse();
      }
    },
    async saveCourse() {
      try {
        const id = await CourseService.save(this.dataRegistration);
        this.dataRegistration.id = id;
        this.clearInputs();
        this.$toast.open({
          message: "Aluno Aprovado",
          type: "success",
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateCourse(validDocuments) {
      try {
        const payload = {
          status: this.dataRegistration.status,
          documentsValids: validDocuments,
          observation: this.dataRegistration.observation,
        };

        await CourseService.updateDocuments(
          payload,
          this.dataRegistration.student.id,
          this.dataRegistration.course.id
        );

        this.clearInputs();
        this.$toast.open({
          message: "Documentos atualizados com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);

        this.handleError(error);
      }
    },
    handleError(error) {
      const message = error?.response?.data?.message;
      const typeError = HandleErrors(message);
      if (typeError) {
        this.$toast.open({
          message: typeError.message,
          type: "info",
        });
      } else {
        toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    async studentsCombobox() {
      const { data } = await CourseService.comboboxStudents();
      this.allStudents = data;
    },

    assingEditRegistration() {
      Object.assign(this.dataRegistration, this.dataSearchRegistration);
      Object.assign(
        this.responsible,
        this.dataRegistration.studentCourse.responsibles
      );
      Object.assign(
        this.bondmand,
        this.dataRegistration.studentCourse.bondsmans
      );

      this.dataRegistration.cpf = this.student.cpf;
      this.dataRegistration.id = this.dataSearchRegistration.id;
      this.dataRegistration.name = this.student.name;
      this.dataRegistration.address = this.student.address;
      this.dataRegistration.district = this.student.district;
      this.dataRegistration.city = this.student.city;
      this.dataRegistration.number = this.student.number;
      this.dataRegistration.courseName =
        this.dataSearchRegistration.course.name;
      this.dataRegistration.phone = this.student.phone;
      this.dataRegistration.email = this.student.email;
      this.dataRegistration.uf = this.student.uf;
      this.dataRegistration.instagram = this.student.instagram;
      this.dataRegistration.cursosEscolhido = this.student.cursosEscolhido;
      this.dataRegistration.faculdadesEscolhidas =
        this.student.faculdadesEscolhidas;
      this.dataRegistration.observation =
        this.dataSearchRegistration.observation;
    },

    async assingOtherObject(data) {
      const result = await CourseService.getStudentById(data.student.id);
      this.student = result.data;
      const dataa = await CourseService.getCourseId(data.course.id);
      this.course = dataa.data;
      const matchingCourse = this.student.studentCourse.find(
        (course) => course.courseId === this.course.id
      );
      this.dataRegistration.studentCourse = matchingCourse;
      if (matchingCourse?.documentsApproved) {
        this.documentsValids =
          matchingCourse.documentsApproved.documentsValids || {};
      } else {
        this.documentsValids = {};
      }
      const documents = await CourseService.getFiles(
        this.dataRegistration.studentCourse.id,
        "student-course"
      );
      this.files = documents.data;

      const mapFiles = (keys) =>
        keys
          .map((type) => this.files.find((file) => file.fileType === type))
          .filter(Boolean);

      this.filesStudent = mapFiles([
        "rg",
        "pix",
        "rg-verso",
        "cpf",
        "compResi",
        "compResiOrigem",
        "declaração-ensino-medio-escola-publica",
      ]);
      this.filesResp = mapFiles([
        "rgresp",
        "cpfresp",
        "rgresp-verso",
        "comproResiResp",
      ]);
      this.filesBond = mapFiles([
        "rgFiador",
        "cpfFiador",
        "rgFiador-verso",
        "comproResiFiador",
      ]);
    },

    async downloadFile(refId, typeFile) {
      try {
        await CourseService.downloadFiles(
          parseInt(refId),
          typeFile,
          "student-course"
        );
      } catch (error) {
        this.$toast.open({
          message: "Erro ao baixar arquivo",
          type: "info",
        });
      }
    },

    initializeValidDocuments() {
      const allFiles = [
        ...this.filesStudent,
        ...this.filesResp,
        ...this.filesBond,
      ];

      allFiles.forEach((file) => {
        const fileType = file.fileType;

        const validDocuments =
          this.dataRegistration.studentCourse?.documentsApproved
            ?.documentsValids || {};

        this.$set(this.fileModel, fileType, validDocuments[fileType] || false);
      });
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
    checkInputLength() {
      if (this.dataUser.cpf.length === 18) this.$forceUpdate();
    },

    async updateResponsible() {
      try {
        await CourseService.updateResponsible(this.responsible);

        this.$toast.open({
          message: "Responsável atualizado com sucesso",
          type: "success",
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async updateBondsman() {
      try {
        await CourseService.updateBondsman(this.bondmand);
        this.$toast.open({
          message: "Fiador atualizado com sucesso",
          type: "success",
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async findById() {
      try {
        const data = await CourseService.getStudentById(
          this.dataRegistration.student.id
        );
        this.openModalToReceive(data.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    openModalToReceive(students) {
      this.SET_DATA_SEARCH_FROM_STUDENT(students);
      this.openModals("modalStudent");
    },
  },
  async mounted() {
    if (this.dataSearchRegistration.id) {
      await this.assingOtherObject(this.dataSearchRegistration);
      this.assingEditRegistration();
    }

    this.initializeValidDocuments();
    this.studentsCombobox();
  },
  beforeDestroy() {
    this.clearInputs();
  },
};
</script>
<style scoped>
.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 60px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
}

.form-group {
  margin-bottom: 0.2rem;
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitle {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.user-label1 {
  position: absolute;
  left: 10px;
  font-size: 10px;
  bottom: 23px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background: white;
}

.fixedSelect {
  position: absolute;
  left: 3px;
  font-size: 11px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  bottom: 13px;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 4px;
  width: 100%;
  max-width: 100%;
}

.rowDocs {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 35px;
  gap: 20px;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  justify-content: space-between;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 100px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.rowDocs:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.pa-md {
  padding: 0px;
  width: 100%;
}

.editor-content {
  font-size: 13px !important;
}
.expansion-item {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.editor-content {
  padding: 6px;
}

.material-icons {
  font-size: 13px !important;
}
.ql-editor {
  font-size: 13px !important;
}
.containerContract {
  display: flex;
  justify-content: center;
  padding-top: 70px;
  width: 80%;
  margin: 0 auto;
}

.leftImg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rightImg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  position: relative;
}

.image-container {
  width: 20%;
}

.input-container {
  width: 80%;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.input-group {
  width: 100% !important;
}

.contentImg > div {
  display: flex;
}

.contentImg .logo {
  height: 135px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

#input_file {
  display: none;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.user-label-img {
  font-size: 11px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  margin-top: 0.3rem;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}
.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.radio-input {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}

.cyberpunk-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #0188c8;
  border-radius: 5px;
  background-color: transparent;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.cyberpunk-checkbox:before {
  content: "";
  background-color: #0188c8;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 10px;
  height: 10px;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}

.cyberpunk-checkbox:checked:before {
  transform: translate(-50%, -50%) scale(1);
}

.cyberpunk-checkbox-label {
  font-size: 14px;
  color: #454545;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.selectPlusImg {
  position: relative;
  width: 23%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: relative;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 40px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowContentImg {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 40px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 165px;
  height: 30px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .contentImg {
    flex-direction: column;
  }

  .rightImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    flex-direction: column;
  }

  .rowContentImg {
    display: flex;
    width: 100%;
    gap: 0px;
    flex-direction: column;
    align-items: center;
  }

  .borderInput {
    width: 100%;
  }

  .selectPlusImg {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
